import { merge } from 'ramda';
import {
  OPEN_MODAL_RENEW_STANDARD_TIME,
  CLOSE_MODAL_RENEW_STANDARD_TIME,
  FAIL_RENEW_STANDARD_TIME,
  REQUEST_RENEW_STANDARD_TIME
} from 'src/store/actions/renewStandardTimesActions';

const initialState = {
  open: false,
  fetching: false,
  errors: []
};

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_MODAL_RENEW_STANDARD_TIME:
      return merge(state, { open: true });
    case CLOSE_MODAL_RENEW_STANDARD_TIME:
      return merge(state, { open: false, fetching: false });
    case REQUEST_RENEW_STANDARD_TIME:
      return merge(state, { fetching: true });
    case FAIL_RENEW_STANDARD_TIME:
      return merge(state, { fetching: false, errors: action.error });
    default:
      return state;
  }
};

export default usersReducer;
